import SEOHead, { SITE_URL, SITE_NAME } from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import WhySection from './components/WhySection';
import CategoryGrid from './components/CategoryGrid';
import FeatureGrid from './components/FeatureGrid';
import SeoArticlesSection from './components/SeoArticlesSection';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import SafetySection from './components/SafetySection';

const HOMEPAGE_TITLE = 'Mulebuy Spreadsheet Guide – The Most Complete Mulebuy Spreadsheet Resource Hub';
const HOMEPAGE_DESC = 'Learn how the Mulebuy spreadsheet system works, compare tools, and discover safe efficient ways to shop using Mulebuy spreadsheet platforms. Complete guides, comparisons, and safety analysis for smarter global shopping.';
const HOMEPAGE_KEYWORDS = 'mulebuy spreadsheet, mulebuy spreadsheet guide, mulebuy spreadsheet system, how mulebuy spreadsheet works, mulebuy spreadsheet review';

const homepageJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description: HOMEPAGE_DESC,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    description: HOMEPAGE_DESC,
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title={HOMEPAGE_TITLE}
        description={HOMEPAGE_DESC}
        keywords={HOMEPAGE_KEYWORDS}
        canonicalPath="/"
        ogType="website"
        jsonLd={homepageJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <WhySection />
        <AboutSection />
        <CategoryGrid />
        <FeatureGrid />
        <SeoArticlesSection />
        <CTASection />
        <TestimonialSection />
        <SafetySection />
      </main>
      <Footer />
    </div>
  );
}